/* @ngInject */
function avatarService ($translate) {
  var service = {
    getMoreUsersAvatarText
  }
  return service

  function getMoreUsersAvatarText (value) {
    return $translate.instant('xMoreUsers', { users: value })
  }
}

export { avatarService }
